import React from "react";
import withIconComponent from "../withIconComponent";

var Fullscreen77 = function Fullscreen77() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16l-7 7M23 1l-7 7M16 16l7 7M1 1l7 7",
    strokeLinecap: "butt",
    "data-cap": "butt",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 1h6v6M7 23H1v-6M1 7V1h6M23 17v6h-6"
  }));
};

export default withIconComponent("UiFullscreen77", false)(Fullscreen77);